module.exports = __webpack_public_path__ + "img/new-zealand.57b3ef56.png";